import { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../App";
import { CDN_URL, formatDate, roundToTwoDecimals } from "../Helpers";
import { MdCall, MdMessage, MdWhatsapp } from "react-icons/md";
import { GiPathDistance } from "react-icons/gi";
import { RiPinDistanceLine } from "react-icons/ri";

export default function OneHotelFeed({ data, unClickable = false }) {
	const appContext = useContext(AppContext);

	/* Place states here */


	function view() {
		window.open("https://avanhotels.com/app/", "_blank");
	}

	return (
		<div
			className=""
			onClick={view}
			style={{
				width: "100%",
				height: "200px",
				padding: "0",
				borderRadius: "20px",
				overflow: "hidden",
				position: 'relative',
				marginBottom: "10px",
				backgroundImage: `url(${CDN_URL + data.photo1})`,
				backgroundPosition: 'center',
				backgroundSize: 'cover',
				cursor: "pointer",
			}}
		>

			<div
				style={{
					width: "100%",
					height: "100%",
					background: "linear-gradient(to bottom, rgba(0, 0, 0, 0) 20%, rgba(0, 0, 0, 1) 100%)",
				}}
			>
				<h6
					style={{
						fontSize: "18px",
						position: 'absolute',
						bottom: "0",
						left: "0",
						padding: "10px"
					}}
					className="text-light"
				>
					{data.name}

					
				</h6>

				
			</div>

			
		</div>
	);
}
